export enum VDDTabs {
  ACTIVE_VENDORS = "ActiveVendors",
  ALL_CONTRACTS = "Contracts",
  TEMPLATES = "Templates",
  RISK_ASSESSMENT_TEMPLATES = "RiskAssessmentTemplates",
  INACTIVE_VENDORS = "InactiveVendors",
}
